<template>
  <v-container fill-height class="my-5">
    <v-layout>
      <v-flex xs12>
        <v-card outlined>
          <v-card-title>
            <v-icon
              medium
              left>
              mdi-briefcase-account
            </v-icon>
            <span class="title">Job List</span>
          </v-card-title>
          <v-tabs
            v-model="tabdata"
            :background-color="maincolor"
            centered
            dark
            icons-and-text
            show-arrows>
            <v-tabs-slider color="pink"></v-tabs-slider>
            <v-tab href="#tab-list">
              Jobs
              <v-icon large>mdi-briefcase-check</v-icon>
            </v-tab>
            <v-tab href="#tab-addnew">
              Post New
              <v-icon large>mdi-briefcase-plus</v-icon>
            </v-tab>
          </v-tabs>
          <v-tabs-items :touchless="true" v-model="tabdata">
            <v-tab-item value="tab-list">
              <v-card flat>
                <v-card-text>
                  <v-container>
                    <v-row justify="center">
                      <v-col cols="12" md="2">
                        <v-autocomplete
                          v-model="filter.valid"
                          :items="listvalid"
                          label="Is Valid">
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="3">
                        <v-autocomplete
                          v-model="filter.type"
                          :items="listtype"
                          label="Job Type">
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="5">
                        <v-text-field
                          v-model="filter.search"
                          append-icon="search"
                          label="Search"
                          single-line
                          hide-details>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-btn
                          large
                          block
                          :color="maincolor"
                          class="mt-1 white--text"
                          @click="getJobs">
                          <v-icon left dark>search</v-icon>
                          Cari
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <div class="text-center" v-if="loading.getdata">
                          <v-progress-circular
                            :width="3"
                            color="red"
                            indeterminate>
                          </v-progress-circular>
                        </div>
                        <v-data-table
                          v-if="!loading.getdata"
                          :headers="headers"
                          :items="datalist"
                          :search="filter.search">
                          <template v-slot:[`item.job_salary`]="{ item }">
                            {{ item.job_salary | rupiahformat }}
                          </template>
                          <template v-slot:[`item.action`]="{ item }">
                            <v-btn
                              :to="{ name: 'JobdetailCompany', query: { jobid: item.job_id } }"
                              small
                              icon>
                              <v-icon>search</v-icon>
                            </v-btn>
                            <v-btn
                              @click="editJob(item)"
                              small
                              icon>
                              <v-icon>edit</v-icon>
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item value="tab-addnew">
              <v-card flat>
                <v-card-text>
                  <v-container>
                    <v-form
                      @submit.prevent="submitAdd"
                      ref="formaddjob"
                      v-model="formadd.valid"
                      lazy-validation>
                      <v-row justify="center">
                        <v-col cols="12" md="5">
                          <v-row>
                            <v-col cols="12" md="12">
                              <v-text-field
                                v-model="addjob.job_name"
                                :rules="[rules.required]"
                                label="Job title *"
                                name="jobtitle"
                                required>
                              </v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                              <v-text-field
                                v-model="addjob.job_salary"
                                :rules="[rules.required]"
                                label="Job salary *"
                                name="jobsalary"
                                required
                                type="number">
                              </v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                              <v-autocomplete
                                v-model="addjob.job_type"
                                :items="listtype"
                                :rules="[rules.required]"
                                label="Job type *">
                              </v-autocomplete>
                            </v-col>
                            <v-col cols="12" md="12">
                              <v-autocomplete
                                v-model="addjob.job_special"
                                :items="listspecial"
                                :rules="[rules.required]"
                                label="Specialization *">
                              </v-autocomplete>
                            </v-col>
                            <v-col cols="12" md="12">
                              <v-autocomplete
                                v-model="addjob.job_location"
                                :items="listlocation"
                                :rules="[rules.required]"
                                label="Location *">
                              </v-autocomplete>
                            </v-col>
                            <v-col cols="12" md="12">
                              <v-menu
                                v-model="datepick.addtgljob"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px">
                                <template v-slot:activator="{ on }">
                                  <v-text-field
                                    v-model="addjob.job_valid"
                                    label="Valid until *"
                                    v-on="on"
                                    :rules="[rules.required]">
                                  </v-text-field>
                                </template>
                                <v-date-picker
                                  :min="datepick.date"
                                  v-model="addjob.job_valid"
                                  @input="datepick.addtgljob = false">
                                </v-date-picker>
                              </v-menu>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="12" md="7">
                          <v-row>
                            <v-col cols="12">
                              <v-textarea
                                name="prev"
                                label="Preview (Max 200 Character) *"
                                placeholder="Job preview..."
                                counter
                                rows="1"
                                auto-grow
                                v-model="addjob.job_preview"
                                :rules="[rules.required, rules.textlimit]">
                              </v-textarea>
                            </v-col>
                            <v-col cols="12">
                              <div>Description</div>
                              <vue-editor
                                v-model="addjob.job_desc"
                                placeholder="Job description... *"
                                :rules="[rules.required]">
                              </vue-editor>
                            </v-col>
                            <v-col cols="12">
                              <alertsp :alertdata="alertdata"></alertsp>
                              <v-btn
                                type="submit"
                                large
                                block
                                :loading="loading.adddata"
                                :disabled="loading.login || !formadd.valid"
                                :color="maincolor"
                                class="white--text">
                                Post
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- modal - update -->
    <v-dialog
      v-model="dmodal.job"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition">
      <v-card v-if="dmodaldata.job">
        <v-toolbar :color="maincolor" dark class="px-md-5" flat>
          <v-toolbar-title>
            Update Job {{ dmodaldata.job.job_name }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDmodal('jobedit')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <v-form
              @submit.prevent="submitUpdate"
              ref="formupdatejob"
              v-model="formupdate.valid"
              lazy-validation>
              <v-row justify="center">
                <v-col cols="12" md="5">
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="dmodaldata.job.job_name"
                        :rules="[rules.required]"
                        label="Job title *"
                        name="jobtitle"
                        required>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="dmodaldata.job.job_salary"
                        :rules="[rules.required]"
                        label="Job salary  *"
                        name="jobsalary"
                        required
                        type="number">
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-autocomplete
                        v-model="dmodaldata.job.job_type"
                        :items="listtype"
                        :rules="[rules.required]"
                        label="Job type *">
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="12">
                      <v-autocomplete
                        v-model="dmodaldata.job.job_special"
                        :items="listspecial"
                        :rules="[rules.required]"
                        label="Specialization *">
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="12">
                      <v-autocomplete
                        v-model="dmodaldata.job.job_location"
                        :items="listlocation"
                        :rules="[rules.required]"
                        label="Location *">
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="12">
                      <v-menu
                        v-model="datepick.updtgljob"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px">
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="dmodaldata.job.job_valid"
                            label="Valid until *"
                            v-on="on"
                            :rules="[rules.required]">
                          </v-text-field>
                        </template>
                        <v-date-picker
                          :min="datepick.date"
                          v-model="dmodaldata.job.job_valid"
                          @input="datepick.updtgljob = false">
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="7">
                  <v-row>
                    <v-col cols="12" md="12">
                      <v-textarea
                        name="prev"
                        label="Preview (Max 200 Character) *"
                        placeholder="Job preview..."
                        counter
                        rows="1"
                        auto-grow
                        v-model="dmodaldata.job.job_preview"
                        :rules="[rules.required, rules.textlimit]">
                      </v-textarea>
                    </v-col>
                    <v-col cols="12" md="12">
                      <div>Description</div>
                      <vue-editor
                        v-model="dmodaldata.job.job_desc"
                        placeholder="Job description... *"
                        :rules="[rules.required]">
                      </vue-editor>
                    </v-col>
                    <v-col cols="12" md="12" v-if="alertupdate.show">
                      <alertsp :alertdata="alertupdate"></alertsp>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-btn
                        large
                        block
                        color="error"
                        @click="closeDmodal('jobedit')">
                        Cancel
                      </v-btn>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-btn
                        large
                        block
                        :loading="loading.uptdata"
                        :disabled="loading.uptdata || !formupdate.valid"
                        :color="maincolor"
                        class="white--text"
                        type="submit">
                        Update
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import { mapState } from 'vuex';
import { VueEditor } from 'vue2-editor';
import { priceFromat } from '@/plugins/utils';

export default {
  name: 'JobsCompany',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertupdate: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      getdata: false,
      adddata: false,
      uptdata: false,
    },
    api: process.env.VUE_APP_API,
    baseurl: process.env.VUE_APP_BASEURL,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    listlocation: ['BADUNG', 'DENPASAR', 'GIANYAR', 'TABANAN'],
    listtype: ['full-time', 'part-time', 'interenship'],
    listspecial: ['IT-Software', 'IT-Hardware', 'Hotel', 'Tourism', 'Public Relations', 'Banking', 'Accounting'],
    liststatus: ['active', 'passive'],
    listvalid: ['yes', 'no'],
    filter: {
      type: 'full-time',
      search: '',
      valid: 'yes',
    },
    headers: [
      { text: 'Name', value: 'job_name' },
      { text: 'Type', value: 'job_type' },
      { text: 'Salary', value: 'job_salary' },
      { text: 'Specialization', value: 'job_special' },
      { text: 'Valid date', value: 'job_valid' },
      { text: 'Applicant', value: 'jum' },
      { text: 'Actions', value: 'action', sortable: false, align: 'center' },
    ],
    datalist: [],
    addjob: {
      job_name: '',
      job_salary: '',
      job_type: '',
      job_special: '',
      job_location: '',
      job_preview: '',
      job_valid: '',
      job_desc: '',
    },
    formadd: {
      password: false,
      valid: false,
    },
    formupdate: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => (v) && v.length >= 8 || 'Min 8 characters',
      nik: (v) => (v) && v.length >= 16 || 'Min 16 characters',
      textlimit: (v) => (v) && v.length <= 200 || 'Max 200 characters',
      files: [
        (value) => !value || value.size < 500000 || 'File kurang dari 500 Kb!',
      ],
    },
    tabdata: null,
    dmodal: {
      job: false,
    },
    dmodaldata: {
      job: null,
    },
    datepick: {
      date: new Date().toISOString().substr(0, 10),
      addtgljob: false,
      updtgljob: false,
      updatetglberita: false,
    },
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  mounted() {
    this.getJobs();
  },
  filters: {
    dateToAge(value) {
      return value;
    },
    // For filter render
    rupiahformat(value) {
      if (!value) {
        return '';
      } else {
        return priceFromat(value, 'Rp');
      }
    },
  },
  methods: {
    getJobs() {
      this.loading.getdata = true;
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/jobs/',
            {
              params: this.filter,
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.datalist = resdata.data;
              }
            }
            this.loading.getdata = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.getdata = false;
          });
      }
    },
    submitAdd() {
      this.alertdata.show = false;
      if (this.$refs.formaddjob.validate()) {
        if (this.tokenscr) {
          this.loading.adddata = true;
          const dataadd = this.addjob;
          const formData = new FormData();
          // data send
          formData.append('job_name', dataadd.job_name);
          formData.append('job_salary', dataadd.job_salary);
          formData.append('job_type', dataadd.job_type);
          formData.append('job_special', dataadd.job_special);
          formData.append('job_location', dataadd.job_location);
          formData.append('job_preview', dataadd.job_preview);
          formData.append('job_valid', dataadd.job_valid);
          formData.append('job_desc', dataadd.job_desc);
          this.axios
            .post(
              this.api + '/api/jobs/',
              formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  // reset
                  this.$refs.formaddjob.reset();
                  this.addjob.job_desc = '';
                  // alert
                  this.alertdata.show = true;
                  this.alertdata.type = 'success';
                  this.alertdata.text = resdata.data + '" job posted successfully!';
                  // refresh
                  this.getJobs();
                } else {
                  this.alertdata.show = true;
                  this.alertdata.type = 'error';
                  this.alertdata.text = resdata.message;
                }
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = 'Internal services error!';
              }
              this.loading.adddata = false;
            })
            .catch((error) => {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
              this.loading.adddata = false;
            });
        } else {
          this.alertdata.show = true;
          this.alertdata.type = 'error';
          this.alertdata.text = 'Invalid token!';
        }
      }
    },
    closeDmodal(type) {
      if (type === 'jobedit') {
        this.dmodal.job = false;
      } else {
        this.dmodal.job = false;
      }
    },
    editJob(item) {
      this.dmodal.job = true;
      this.dmodaldata.job = JSON.parse(JSON.stringify(item));
    },
    submitUpdate() {
      this.alertupdate.show = false;
      if (this.$refs.formupdatejob.validate()) {
        if (this.tokenscr) {
          this.loading.uptdata = true;
          this.axios
            .put(
              this.api + '/api/jobs/',
              qs.stringify(
                this.dmodaldata.job,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                // console.log(resdata);
                if (resdata.error === false) {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'success';
                  // tslint:disable-next-line:max-line-length
                  this.alertupdate.text = this.dmodaldata.job.job_name + '" has been changed successfully!';
                  this.getJobs();
                } else {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'error';
                  this.alertupdate.text = resdata.message;
                }
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = 'Internal services error!';
              }
              this.loading.uptdata = false;
            })
            .catch((error) => {
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
              this.loading.uptdata = false;
            });
        } else {
          this.alertupdate.show = true;
          this.alertupdate.type = 'error';
          this.alertupdate.text = 'Invalid token!';
        }
      }
    },
  },
  components: {
    Alertsp,
    VueEditor,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
